<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/productrecord/add')">新增</el-button>
        <el-button type="primary" v-if="hasExport && searchForm.ygType === 'B'" @click="onExport">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <!-- 新增规格specName筛选项，放在所属客户之前 -->
        <el-form-item label="品种规格" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="品种规格" />
        </el-form-item>

        <el-form-item label="所属客户" prop="userId">
          <el-select v-model="searchForm.userId" filterable :clearable="true">
            <el-option :label="item.userName" :value="item.userId" v-for="item in userList"
                       :key="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属仓库" prop='warehouseName'>
          <el-input clearable v-model="searchForm.warehouseName" placeholder="所属仓库" />
        </el-form-item>
        <el-form-item label="类型" prop="ygType">
          <el-select v-model="searchForm.ygType" :clearable="true">
            <el-option label="出库" value="A"></el-option>
            <el-option label="入库" value="B"></el-option>
            <el-option label="货转调拨" value="A3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流水编号" prop='objNum'>
          <el-input clearable v-model="searchForm.objNum" placeholder="流水编号" />
        </el-form-item>
        <el-form-item label="记录来源" prop="sourceType">
          <el-select v-model="searchForm.sourceType" :clearable="true">
            <el-option :label="item[1]" :value="item[0]" v-for="item of Array.from(recordSourceTypeMap)"
                       :key="item[0]"></el-option>
          </el-select>
        </el-form-item>

        <!-- 新增 日期时间段筛选 -->
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button type="success" @click="onAddPerformance">批量填写绩效</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属客户" prop="userName"></el-table-column>
        <el-table-column min-width="230" label="流水编号" prop="objNum">
          <template v-slot="{ row }">
            <el-button type="text" @click="toDetail(row)">{{ row.objNum }}</el-button>
            <el-button type="text" @click.stop="handleCopyText(row.objNum)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属仓库"
                         prop="warehouseName"></el-table-column>
        <el-table-column min-width="80" label="类型" prop="ygType">
          <template v-slot="{ row }">
            {{ row.ygType === 'B' ? '入库' : '出库' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="出入库类型" prop="recType">
          <template v-slot="{ row }">
            {{ cyRecTypeMap.get(row.recType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="100" label="数量" prop="recQuantity"></el-table-column>
        <el-table-column min-width="100" :show-overflow-tooltip="true" label="记录来源" prop="sourceType">
          <template v-slot="{ row }">
            {{ recordSourceTypeMap.get(row.sourceType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录时间" prop="ctime"></el-table-column>
        <el-table-column min-width="100" label="绩效系数" prop="performanceCoefficient">
          <template v-slot="{ row }">
            <span v-if="row.performanceCoefficient" style="color:green;">{{row.performanceCoefficient}}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>

        <el-table-column width="120" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/inventoryflow/detail?id=' + row.id)">详情</el-button>
            <el-button type="text" v-if="hasPerformance" @click="openPerformanceDialog(row)">绩效</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 绩效系数弹窗 -->
    <el-dialog title="设置绩效系数" :visible.sync="performanceDialogVisible" width="450px">
      <el-form :model="performanceForm" ref="performanceFormRef" label-width="120px">
        <el-form-item label="绩效系数" prop="performanceCoefficient" :rules="[{ required: true, message: '请输入绩效系数', trigger: 'change' }]">
          <el-input-number v-model="performanceForm.performanceCoefficient" :min="0" placeholder="请输入绩效系数" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="performanceDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPerformance">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { cyRecType, recordSourceType } from '@/utils/dict'
import { copyText, deepClone } from '@/utils/utils'

export default {
  name: 'InventoryFlow',
  mixins: [keepAlive],
  data() {
    return {
      cyRecTypeMap: cyRecType,
      recordSourceTypeMap: recordSourceType,
      userList: [],
      warehouseList: [],
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      // 日期范围
      dateRange: [],
      searchForm: {
        specName: '', // 新增规格筛选字段
        warehouseName: '',
        ygType: '',
        objNum: '',
        sourceType: '',
        userId: '',
        startDate: '',
        endDate: ''
      },
      // 绩效弹窗
      performanceDialogVisible: false,
      currentWareRecId: '',
      performanceForm: {
        performanceCoefficient: null
      }
    }
  },
  created() {
    this.loadData()
    this.loadUserList()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasPerformance() {
      return this.buttonList.includes('performance')
    }
  },
  methods: {
    // 批量填写绩效
    onAddPerformance() {
      this.currentWareRecId = ''
      this.performanceForm.performanceCoefficient = 0
      this.performanceDialogVisible = true
    },
    // 打开绩效弹窗
    openPerformanceDialog(row) {
      this.currentWareRecId = row.id
      this.performanceForm.performanceCoefficient = row.performanceCoefficient || 0
      this.performanceDialogVisible = true
    },
    // 提交绩效
    async submitPerformance() {
      try {
        await this.$refs.performanceFormRef.validate()
      } catch (e) {
        return
      }
      try {
        let url = this.$apis.performance.insertYgPerformance
        let obj = { ...this.performanceForm }
        if (this.currentWareRecId) {
          obj = { ...obj, wareRecId: this.currentWareRecId }
        } else {
          url = this.$apis.performance.insertYgPerformanceByCondition
          obj = { ...obj, ...this.searchForm }
        }
        await this.$axios.post(url, obj)
        this.$message.success('保存成功')
        this.performanceDialogVisible = false
        this.loadData()
      } catch (err) {
        console.error(err)
      }
    },
    toDetail(row) {
      // 储运跳转
      if (row.sourceType === 'CY') {
        this.$router.push('/cyCrkManage/detail?inventoryId=' + row.objId + '&recordType=' + row.recType)
      } else if (row.sourceType === 'YC') {
        this.$router.push('/ycdeliveryOrder/detail?pickupId=' + row.objId)
      } else if (row.sourceType === 'SC') {
        this.$router.push('/productrecord/detail?recordId=' + row.objId)
      } else if (row.sourceType === 'TH') {
        this.$router.push('/deliveryOrder/detail?pickupId=' + row.objId)
      }
    },
    // 复制文本
    async handleCopyText(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadData() {
      this.loading = true
      // 赋值开始/结束日期
      if (this.dateRange && this.dateRange.length === 2) {
        this.searchForm.startDate = this.dateRange[0]
        this.searchForm.endDate = this.dateRange[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }

      const form = deepClone(this.searchForm)
      if (form.ygType === 'A3') {
        form.ygType = ''
        form.recType = 'A3'
      }
      this.$axios.get(this.$apis.prodManage.selectLyWareRecByPage, {
        page: this.page,
        size: 10,
        ...form
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      // 重置日期选择器
      this.dateRange = []
      this.onSearch()
    },
    deleteRow(recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.prodManage.deleteScProRecord, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    onExport() {
      if (!this.searchForm.objNum) {
        this.$message.error('请输入要导出的流水编号')
      } else {
        const loadingInstance = this.$loading({
          text: '正在导出...',
          background: 'rgba(0, 0, 0, 0.8)'
        })
        this.$axios.post(this.$apis.prodManage.selectLyWareRecByPdf, {
          objNum: this.searchForm.objNum
        }, {
          responseType: 'blob'
        }).then(res => {
          if (res) {
            const contentDisposition = res.headers['content-disposition']
            let fileName = this.searchForm.objNum + '_确认单.pdf'
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
              if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1]
              }
            }
            this.downloadFile(res.data, fileName)
          }
        }).catch(error => {
          console.error('导出失败:', error)
        }).finally(() => {
          loadingInstance.close()
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
<style lang='scss'>
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
